import { roleHasPermission, type Permission } from '@/config/permissions';
import { useAuth, useIsPlatformAdmin, useRole } from '@/providers/AuthProvider';

/** Permission checks for nav filtering, command bar, and route guards. */
export function usePermissions() {
  const role = useRole();
  const isPlatformAdmin = useIsPlatformAdmin();
  const { isAuthenticated, session } = useAuth();

  const sessionPermissions = session?.permissions;

  const can = (permission: Permission): boolean => {
    if (!isAuthenticated) return false;
    if (sessionPermissions && sessionPermissions.length > 0) {
      return sessionPermissions.includes(permission);
    }
    return roleHasPermission(role, permission);
  };

  const canAny = (permissions: Permission[]): boolean =>
    permissions.some((p) => can(p));

  return { can, canAny, role, isPlatformAdmin, permissions: sessionPermissions };
}
